import React from 'react'
import IconField from './icon-field'
import IconRow from './icon-row'
import DateIconLabel from '../date-icon-label'
import HourDurationIconLabel from '../hour-duration-icon-label'
import LocationIconLabel from '../location-icon-label'
import FacilitatorIconLabel from '../facilitator-icon-label'
import EnrollmentIconLabel from '../enrollment-icon-label'
import Requirements from './requirements'
import DimensionPills from '../../dimensions/pill-list'
import SeriesLabel from './series-label'
import { get } from 'lodash'
import CredtisIconLabel from '../credits-icon-label'
import Cutoff from './cutoff'

const ExperienceDetails = ({
    experience = {},
    requirements = true,
    dimensions = true,
    description = true,
    enrollment = true,
    series = true,
    credits = true
}) => {
    
    return (
        <div>
            <IconRow>
                <IconField  >
                    <FacilitatorIconLabel experience={experience} />
                </IconField>
                <IconField  >
                    <LocationIconLabel experience={experience} />
                </IconField>
            </IconRow>
            <IconRow>
                <IconField  >
                    <DateIconLabel experience={experience} />
                </IconField>
                <IconField  >
                    <HourDurationIconLabel experience={experience} />
                </IconField>
            </IconRow>
            {credits &&
            <IconRow>
                <IconField  >
                    <CredtisIconLabel experience={experience} />
                </IconField>
            </IconRow>
            }
            {series &&
            <IconRow>
                <IconField sm={12}>
                    {get(experience, 'series') && <SeriesLabel experience={experience} />}
                </IconField>
            </IconRow>
            }
            {enrollment &&
            <IconRow>
                <IconField sm={12}>
                    <EnrollmentIconLabel showEnrollees experience={experience} />
                </IconField>
            </IconRow>
            }
            <Cutoff experience={experience} />
            {description &&

            <div style={{ paddingTop: '10px', color: 'black', paddingBottom: '20px'}}>
                {experience.description}
            </div>
            }
            {dimensions &&
            <div>
                <DimensionPills dimensions={experience.dimensions} />
            </div>
            }
            {requirements &&
            <div>
                <Requirements experience={experience} />
            </div>
            }
        </div>
    )
}

export default ExperienceDetails